<span *ngFor="let variation of viewProductVariations; let last = last">
  {{ variation.value }}
  <ng-container *ngIf="!last">|</ng-container>
</span>
